import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function FeedbackGoalPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'REQUEST_ATT',
        }),
      )
    }
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="👏"
      heading={t('pages.onboarding.feedbackGoal.heading')}
      text={t('pages.onboarding.feedbackGoal.text')}
      onSubmit={handleSubmit}
    />
  )
}
